import React, { useState } from "react";
import { callFunction, apiConfig } from "../firebase-config";
import "./AdminPage.css";

function AdminPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    // Simple password protection (in a real app, use proper authentication)
    if (password === "admin123") {
      setIsAuthenticated(true);
      fetchRequests();
    } else {
      setError("Invalid password");
    }
  };

  const fetchRequests = async () => {
    try {
      setLoading(true);

      // Call the Firebase function to get return requests from Firestore
      const functionUrl = `${apiConfig.baseUrl}${apiConfig.endpoints.getReturnRequests}`;

      let response;
      try {
        // First try the Firebase function endpoint
        response = await fetch(functionUrl);
      } catch (fetchError) {
        console.warn(
          "Firebase function not available, falling back to local data:",
          fetchError
        );
        // Fallback to local data if Firebase function is not available
        response = await fetch(
          `${window.location.origin}/data/returnRequests.json`
        );
      }

      const data = await response.json();

      // Check if we have a valid response format
      if (response.ok && data.success && Array.isArray(data.requests)) {
        // API endpoint format
        setRequests(data.requests);
      } else if (Array.isArray(data)) {
        // Local data format
        setRequests(data);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (err) {
      console.error("Error fetching return requests:", err);
      setError("Failed to fetch return requests: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Format date for display
  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleString();
  };

  return (
    <div className="min-h-screen bg-neutral">
      <header>
        <title>Admin | Returns & Exchanges</title>
        <meta
          name="description"
          content="Admin dashboard for returns and exchanges"
        />
      </header>

      <main className="container mx-auto px-4 py-8">
        <div className="bg-white p-6 rounded-shopify shadow-sm">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6">
            Returns & Exchanges Admin
          </h1>

          {!isAuthenticated ? (
            <div className="max-w-md mx-auto">
              <form onSubmit={handleLogin} className="space-y-4">
                <div>
                  <label htmlFor="password" className="label">
                    Password
                  </label>
                  <input
                    id="password"
                    type="password"
                    className="input-field"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                {error && <p className="error-text">{error}</p>}

                <button type="submit" className="btn-primary w-full">
                  Login
                </button>
              </form>
            </div>
          ) : (
            <div>
              {loading ? (
                <p className="text-center py-8">Loading requests...</p>
              ) : error ? (
                <p className="error-text text-center py-8">{error}</p>
              ) : requests.length === 0 ? (
                <p className="text-center py-8">
                  No return or exchange requests found.
                </p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Order
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Customer
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Type
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Items
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Total
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {requests.map((request) => (
                        <tr key={request.id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {request.orderNumber}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {request.customerName}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">
                            {request.returnType}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500">
                            <ul className="list-disc pl-5">
                              {request.items.map((item, index) => (
                                <li key={index}>
                                  {item.name} (Qty: {item.quantity}, Price: $
                                  {item.price || "0.00"})
                                </li>
                              ))}
                            </ul>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            $
                            {request.items
                              .reduce((total, item) => {
                                const itemPrice = parseFloat(item.price) || 0;
                                const itemQuantity =
                                  parseInt(item.quantity) || 0;
                                return total + itemPrice * itemQuantity;
                              }, 0)
                              .toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span
                              className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                request.status === "pending"
                                  ? "bg-yellow-100 text-yellow-800"
                                  : request.status === "approved"
                                  ? "bg-green-100 text-green-800"
                                  : request.status === "rejected"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-gray-100 text-gray-800"
                              }`}
                            >
                              {request.status}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {formatDate(request.createdAt)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="mt-6">
                <button
                  className="btn-primary"
                  onClick={fetchRequests}
                  disabled={loading}
                >
                  Refresh
                </button>
              </div>
            </div>
          )}
        </div>
      </main>

      <footer className="container mx-auto px-4 py-6 text-center text-gray-500 text-sm">
        <p>
          &copy; {new Date().getFullYear()} Dirty Water Donut Shop. All rights
          reserved.
        </p>
      </footer>
    </div>
  );
}

export default AdminPage;
